import React from 'react';
import { updateSafePrivacyMode } from 'api';
import { useSafeSettingsStorage } from 'hooks';
import { useSafeSettings } from 'store';
import { ITrackingSettingsData } from 'types';

import { EmailSettings } from './components/EmailSettings';
import { PrivacySettings } from './components/PrivacySettings';

type SettingsFlags = keyof Omit<ITrackingSettingsData, 'safeId'>;

export const SettingsTab: React.FC = () => {
  const { saveToLocalStorage } = useSafeSettingsStorage();
  const { safeSettings, setSafeSettings } = useSafeSettings();

  const handleChangeFlag = (safeId: string, settingType: SettingsFlags) => {
    const newSettings: ITrackingSettingsData = {
      ...safeSettings,
      safeId,
      [settingType]: !safeSettings[settingType],
    };
    saveToLocalStorage(newSettings);
    setSafeSettings(newSettings);

    if (settingType === 'isPrivacyMode') {
      updateSafePrivacyMode(safeId, newSettings.isPrivacyMode).then();
    }
  };

  return (
    <div className="flex flex-col gap-16 sm:gap-24 w-full">
      <PrivacySettings safeSettings={safeSettings} handleChangeFlag={handleChangeFlag} />
      <EmailSettings />
    </div>
  );
};
